import { createSelector } from 'reselect';
import {
  createABAReducer,
  getABASelectors,
  RequestDataIds,
} from '@corefront/redux-aba';
import { pathOr, path } from 'ramda';
import { DEFAULT_LAYOUT_DIMENSIONS } from '../../../../constants/shells';
import {
  DESKTOP_CHANNELS,
  IOS_NATIVE_CHANNELS,
  MOBILE_CHANNELS,
  NATIVE_CHANNELS,
} from '../../../../constants/channels';
import {
  BRAND_CURRENCY_MAP,
  DEFAULT_CURRENCY,
} from '../../../../constants/currency';

export const initialState = {
  [RequestDataIds.BaseUrl]: '/',
  [RequestDataIds.LayoutDimensions]: DEFAULT_LAYOUT_DIMENSIONS,
  [RequestDataIds.AmsSegments]: [],
};

const reducer = createABAReducer(initialState);

export default reducer;

/**
 * SELECTORS
 */
export const rootSelector = (state) => state.app.params;

export const {
  containerSelector,
  languageSelector,
  baseURLSelector,
  brandSelector,
  channelSelector,
  proxyPrefixSelector,
  userTokenSelector,
  userDataSelector,
  layoutDimensionsSelector,
  platformSelector,
  clientIdSelector,
  AMSSegmentsSelector: AMSSelector,
  crossDomainClickStreamIdSelector,
  brandHashSelector,
  applicationIdSelector,
} = getABASelectors(rootSelector);
export const userCurrencyIdSelector = createSelector(
  userDataSelector,
  (userData) => path(['currency', 'id'], userData)
);
export const userCurrencyNameSelector = createSelector(
  userDataSelector,
  (userData) => path(['currency', 'name'], userData)
);
export const userBalanceSelector = createSelector(
  userDataSelector,
  (userData) => path(['balances', 'total'], userData)
);
export const isLoggedInSelector = createSelector(
  userTokenSelector,
  (userToken) => Boolean(userToken)
);
export const isDesktopSelector = createSelector(channelSelector, (channel) =>
  DESKTOP_CHANNELS.includes(channel)
);
export const isMobileSelector = createSelector(channelSelector, (channel) =>
  MOBILE_CHANNELS.includes(channel)
);
export const isNativeSelector = createSelector(channelSelector, (channel) =>
  NATIVE_CHANNELS.includes(channel)
);
export const isIOSNativeSelector = createSelector(channelSelector, (channel) =>
  IOS_NATIVE_CHANNELS.includes(channel)
);
export const brandCurrencySelector = createSelector(brandSelector, (brand) => {
  const brandCurrency = BRAND_CURRENCY_MAP[brand];
  return brandCurrency ? brandCurrency : DEFAULT_CURRENCY;
});
export const userCurrencySelector = createSelector(
  brandCurrencySelector,
  userDataSelector,
  (defaultCurrency, user) => pathOr(defaultCurrency, ['currency', 'name'], user)
);
export const userNumberSelector = createSelector(
  userDataSelector,
  (user) => user?.number
);
